module.exports = __webpack_public_path__ + "img/iphone-ipad-wifi-turn-on-off.122302fb.png";